import { render, staticRenderFns } from "./WaitForComeBackServicesReservation.vue?vue&type=template&id=4f861956&scoped=true&"
import script from "./WaitForComeBackServicesReservation.vue?vue&type=script&lang=js&"
export * from "./WaitForComeBackServicesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f861956",
  null
  
)

export default component.exports